
import { formatDate3 } from "../../utils/dateFormat";
import { MonthlyData, CircleItem } from "../scatterPlot/types";

// Group the data by metric_name
export const splitDataByMetricName = (data: any) => {
    return data.reduce((acc: any, item: any) => {
        const metricName = item.label;

        return {
            ...acc,
            [metricName]: [...(acc[metricName] || []), item],
        };
    }, {});
};

// Function to filter data by metric_name
export const getFilteredDataByMetricName = (data: any, metricName: any) => {
  const groupedData = splitDataByMetricName(data);
  return groupedData[metricName] || [];
};

// Group non-metric data by month without same-day clubbing
export const groupNonMetricDataByMonth = (data: any): MonthlyData[] => {
  const groupedByMonth: Record<string, CircleItem[]> = {};

  data.forEach((item: any) => {
    const month = new Date(item.conversation_date).toLocaleString("default", {
      month: "long",
      year: "numeric",
    });

    if (!groupedByMonth[month]) groupedByMonth[month] = [];
    groupedByMonth[month].push({
      category: item.coaching_conversation_category_name,
      visible: true,
      message: `${formatDate3(item.conversation_date)} : ${item.conversation_subject}`,
      color: item.display_color,
      id: item.coaching_conversation_id, // Extract id
      date: item.conversation_date,
    });
  });

  return Object.keys(groupedByMonth).map((month) => ({
    month,
    items: groupedByMonth[month],
  }));
};

// Group metric data by month without same-day clubbing
export const groupMetricDataByMonth = (data: any): MonthlyData[] => {
  const groupedByMonth: Record<string, CircleItem[]> = {};

  data.forEach((item: any) => {
    const month = new Date(item.author_comment_date).toLocaleString("default", {
      month: "long",
      year: "numeric",
    });

    if (!groupedByMonth[month]) groupedByMonth[month] = [];
    groupedByMonth[month].push({
      category: "metric",
      visible: true,
      message: `${formatDate3(item.author_comment_date)} : ${item.author_comment}`,
      color: "#7D71E2",
      id: item.coaching_metric_id, // Extract id
      date: item.author_comment_date,
    });
  });

  return Object.keys(groupedByMonth).map((month) => ({
    month,
    items: groupedByMonth[month],
  }));
};